type Reference = { readonly id: number; readonly label: string | null };

/** `missing` when the cost is not attributed to any object, `deleted` when the object no longer exists. */
const resolveReferenceLabel = (reference: Reference | null, missing: string, deleted: string): string => {
	if (reference === null) {
		return missing;
	}

	return reference.label ?? deleted;
};

export default resolveReferenceLabel;
